import { useQuery } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import { getArticleBySlug, ArticlePayload } from "#/services/articles";

export function useArticleDetail(slug?: string) {
  return useQuery<ArticlePayload>({
    queryKey: slug ? qk.articleDetail(slug) : qk.articles(),
    queryFn: ({ signal }) => {
      if (!slug) {
        return Promise.reject(new Error("Article slug is required"));
      }
      return getArticleBySlug(slug, { signal });
    },
    enabled: Boolean(slug),
    staleTime: 30_000,
  });
}

export default useArticleDetail;
